import { useEffect } from 'react';

// Locks page scroll while `lock` is true. Restores previous styles on cleanup.
export function useLockBodyScroll(lock) {
  useEffect(() => {
    if (!lock) return;

    const html = document.documentElement;
    const body = document.body;

    const prevHtmlOverflow = html.style.overflow;
    const prevBodyOverflow = body.style.overflow;
    const prevHtmlTouch = html.style.touchAction;
    const prevBodyTouch = body.style.touchAction;

    html.style.overflow = 'hidden';
    body.style.overflow = 'hidden';
    // Help mobile Safari avoid background scroll/bounce
    html.style.touchAction = 'none';
    body.style.touchAction = 'none';

    return () => {
      html.style.overflow = prevHtmlOverflow;
      body.style.overflow = prevBodyOverflow;
      html.style.touchAction = prevHtmlTouch;
      body.style.touchAction = prevBodyTouch;
    };
  }, [lock]);
}


